import React from 'react';
import styled from 'styled-components';
import { Disableable } from 'spark-ui/ui-kitchen/utensils/Disableable';
import Pill from 'spark-ui/ui-kitchen/ingredients/spices/Pill';

const SelectedItem = styled(Pill)`
    margin: 0 8px 4px 0;
    max-width: 100px;
`;

const PillContainer = styled.div`
	margin: 5px 0 10px;
	display: flex;
	flex-flow: row wrap;
	max-height: 7.5rem;
	overflow-y: auto;
`;
const SelectedItemList = ({selectedItem, setState }) => {
	if (!selectedItem || selectedItem.length <= 0) {
		return null;
	}

	return (
		<PillContainer>
			<Disableable>
				{(getProps) =>
					selectedItem.map((item) => {
						const { onClick, ...disabledProps } = getProps({
							onClick: () =>
								setState({
									selectedItem: selectedItem.filter((i) => i !== item)
								})
						});
						return (
							<SelectedItem key={item.value} removePill={onClick} {...disabledProps}>
								{item.label}
							</SelectedItem>
						);
					})}
			</Disableable>
		</PillContainer>
	);
};

export default SelectedItemList;
